/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  HeaderService,
  IHeaderMethods,
  SettingsService,
  ISettingsMethods,
  PolicyListsService,
  IPolicyListsMethods,
  LoadingService,
  ILoadingMethods,
  IStaticPageContentMethods,
  StaticPageContentService,
  IDownloadPolicyListsMethods,
  DownloadPolicyListsService
} from "./components";

export type ProvisionalPageAgent = IHeaderMethods &
  ISettingsMethods &
  IPolicyListsMethods &
  IStaticPageContentMethods &
  ILoadingMethods &
  IDownloadPolicyListsMethods;

const getPlugins = () => {
  return [
    new HeaderService(),
    new SettingsService(),
    new PolicyListsService(),
    new LoadingService(),
    new StaticPageContentService(),
    new DownloadPolicyListsService()
  ];
};

export const getAgent = () => {
  return createAgent<ProvisionalPageAgent>({
    plugins: getPlugins(),
  });
};
